/* ==========================================================
   Harvest Wellness — behavior
   Stagger-in scroll animation, deliberately tuned to feel more
   premium/slow than Product Showcase or Feature Highlights (longer
   transition, bigger per-item gap). Fires once per page load, the
   first time the section reaches the viewport.

   FIX (page lag / content stuck faded): this used to depend on GSAP
   loaded from a third-party CDN, with content hidden in CSS until
   GSAP's animation revealed it. On a slow/restricted connection to
   that CDN, content could sit there faded/hidden indefinitely, and
   the request itself dragged down the rest of the page. There is no
   external library and no CDN request anymore — this is plain CSS
   transitions (see harvest-wellness.css) turned on by classList
   calls below. Content is fully visible by default regardless of
   whether any of this runs.
   ========================================================== */

(function () {
  "use strict";

  /* Per-item delay step (seconds) within a group, and the extra
     delay added per group so the whole section cascades in turn —
     bigger gaps than the other sections for a slower, more
     deliberate feel. */
  var CONTENT_STAGGER = 0.16;
  var GROUP_DELAY = 0.14;

  function init(root) {
    initStagger(root);
  }

  function initStagger(root) {
    if (root.dataset.stagger === "false") return;
    if (typeof IntersectionObserver === "undefined") return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var groupEls = Array.prototype.slice.call(root.querySelectorAll("[data-stagger-group]"));
    groupEls.forEach(function (groupEl, order) {
      var items = Array.prototype.slice.call(groupEl.querySelectorAll("[data-stagger-item]"));
      if (!items.length) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            /* Fire once only — on first load / first scroll into
               view — not on every re-entry when scrolling back and
               forth. */
            observer.disconnect();
            playGroup(items, order);
          });
        },
        { threshold: 0 }
      );
      observer.observe(groupEl);
    });
  }

  function playGroup(items, order) {
    var groupDelay = order * GROUP_DELAY;

    items.forEach(function (item, i) {
      item.classList.add("stagger-pre");
      item.style.transitionDelay = (groupDelay + i * CONTENT_STAGGER) + "s";
    });

    /* Force the browser to render the "pre" state before switching to
       "in", otherwise it would just snap straight to the end result
       with no visible transition. Two nested requestAnimationFrame
       calls reliably wait for that next paint across browsers. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        items.forEach(function (item) {
          item.classList.remove("stagger-pre");
          item.classList.add("stagger-in");
        });
      });
    });
  }

  document.querySelectorAll("[data-harvest-wellness]").forEach(init);
})();